<template>
  <section class="lg:py-24 py-12">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-12">
        <div class="col-span-12">
          <div class="text-left mb-12">
            <h2
              class="text-3xl sm:text-4xl font-heading font-semibold text-gray-900 mb-4"
            >
              Let's get
              <span class="relative inline-block text-primary-green">
                started
                <svg
                  class="absolute -bottom-2 left-0 w-full"
                  viewBox="0 0 385 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M384 13C255.333 -1.66666 126.667 -1.66666 -2 13"
                    stroke="#3DAB81"
                    stroke-width="3"
                    stroke-linecap="round"
                    class="path-animation"
                  />
                </svg> </span
              >!
            </h2>
            <p class="text-lg text-gray-600">
              Ready to increase conversions, discover more customer journeys and
              improve ad performance?
            </p>
          </div>

          <div class="grid grid-cols-12 gap-8">
            <div class="col-span-12">
              <div
                class="bg-white rounded-2xl border-2 border-[#3DAB81] border-opacity-30 p-6 md:p-8"
              >
                <div class="grid grid-cols-12 gap-6 md:gap-8">
                  <!-- Profile Section -->
                  <div class="col-span-12 md:col-span-3">
                    <div class="flex items-center gap-6">
                      <img
                        src="@/assets/img/profile.png"
                        alt="Tony Rositano"
                        class="w-16 md:w-20 h-16 md:h-20 rounded-full object-cover"
                      />
                      <div>
                        <h3
                          class="text-xl font-heading font-semibold text-gray-900"
                        >
                          Tony Rositano
                        </h3>
                        <p class="text-gray-600">Analytics Engineer</p>
                      </div>
                    </div>
                  </div>

                  <!-- Meeting Points -->
                  <div class="col-span-12 md:col-span-6">
                    <ul class="space-y-3 md:space-y-4">
                      <li class="flex items-start md:items-center gap-3">
                        <svg
                          class="w-6 h-6 text-emerald-500 flex-shrink-0 mt-0.5 md:mt-0"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path
                            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span
                          >Discuss your business stage, goals, and the
                          partnership</span
                        >
                      </li>
                      <li class="flex items-start md:items-center gap-3">
                        <svg
                          class="w-6 h-6 text-emerald-500 flex-shrink-0 mt-0.5 md:mt-0"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path
                            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span>Diagnose pain points & get recommendations</span>
                      </li>
                      <!-- <li class="flex items-start md:items-center gap-3">
                        <svg
                          class="w-6 h-6 text-emerald-500 flex-shrink-0 mt-0.5 md:mt-0"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path
                            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span>Uncover hidden optimization opportunities</span>
                      </li> -->
                    </ul>
                  </div>

                  <!-- CTA Button -->
                  <div
                    class="col-span-12 md:col-span-3 flex items-center justify-end"
                  >
                    <ButtonMain class="w-full md:w-auto">
                      <a
                        href="https://calendly.com/tony-betterinsights/30min"
                        target="_blank"
                        class="text-white"
                      >
                        Book a call
                      </a>
                    </ButtonMain>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import ButtonMain from "@/components/shared/ButtonMain.vue";
</script>

<style scoped>
.path-animation {
  stroke-dasharray: 400;
  stroke-dashoffset: 400;
  animation: draw 1s ease forwards;
}

@keyframes draw {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
